// Material
import { Box, ButtonBase, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.neutral200,
  height: '34px',
  padding: '0 15px 0 5px',
}))

const StyledButton = styled(ButtonBase)(({ theme }) => ({
  ...theme.typography.caption1,
  color: theme.palette.secondary500,
  height: '100%',

  padding: '0 10px',
}))

interface Props {
  primaryText: string
  secondaryText?: string
  secondaryAction?: () => Promise<unknown>
}

export function SearchSection({
  primaryText,
  secondaryText,
  secondaryAction,
}: Props) {
  return (
    <Root>
      <Typography variant="caption1" color="neutral600">
        {primaryText}
      </Typography>

      {secondaryAction && (
        <StyledButton onClick={secondaryAction}>{secondaryText}</StyledButton>
      )}
    </Root>
  )
}
